export default "__VITE_PUBLIC_ASSET__895a814c__"